import { useAtomValue } from "jotai";

import { gdprAtom } from "~/components/tracking/gdpr";

export const useNeedToShowAcquisitionPopupContainerWrapper = () => {
  const { isAccepted: isAcceptedGDPR } = useAtomValue(gdprAtom);
  return isAcceptedGDPR;
};
